import { useTypesStore } from '../store/Types';
import { useTypesRender } from '../utils/useRender';
export var Null = props => {
  var {
    Null: Comp = {}
  } = useTypesStore();
  useTypesRender(Comp, props, 'Null');
  return null;
};
Null.displayName = 'JVR.Null';